"use client";

import { useSettingBackendCarouselComponentHorizontalPadding } from "@faire/retailer-visitor-shared/settings/useSettingBackendCarouselComponentHorizontalPadding";
import { Column } from "@faire/web/slate/Layout/Column";

export const SDUICarouselRendererWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const enableBackendDrivenCarouselPadding =
    useSettingBackendCarouselComponentHorizontalPadding();
  return (
    <Column
      className={enableBackendDrivenCarouselPadding ? undefined : "md:px-12"}
      data-test-id="carousel-renderer"
    >
      {children}
    </Column>
  );
};
